export const EMPLOYEE_DEVELOPMENT_ACTIONS = {
  create: 'create',
  delete: 'delete',
  edit: 'edit',
};

export const DEFAULT_INTERVIEW_TYPE_TO_DELETE = { action: '', data: { name: '', _id: '' } };
